import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { Analytics, CannabisShowcaseAnalytics } from "./Analytics";

const CannabisShowCaseModal = ({ item, restUrl }) => {
    const [sellerInfo, setSellerInfo] = useState({
        loading: true,
        sellerData: null,
        productData: null,
        error: false
    });

    const { loading, sellerData, productData, error } = sellerInfo;

    useEffect(() => {
        const sellerRequest = axios.get(sellerURL);

        const productRequest = axios.get(productURL);

        axios
            .all([sellerRequest, productRequest])
            .then(
                axios.spread((...responses) => {
                    const sellerResponse = responses[0];

                    const productResponse = responses[1];

                    setSellerInfo({
                        ...sellerInfo,
                        sellerData: sellerResponse.data,
                        productData: productResponse.data,
                        error: false,
                        loading: false
                    });

                    if (item) {
                        // Push view event to Google Tag Manager
                        Analytics.view(
                            CannabisShowcaseAnalytics.makeInformationEventProperties(
                                "Cannabis Showcase Information_",
                                item[0],
                                productResponse.data.external_link
                            )
                        );
                    }
                })
            )
            // .get(sellerURL)
            // .then(data => {
            //     setSellerInfo({
            //         ...sellerInfo,
            //         sellerData: data.data,
            //         error: false,
            //         loading: false
            //     });
            // })
            .catch(err => {
                setSellerInfo({
                    ...sellerInfo,
                    error: true,
                    loading: false
                });
                console.error(err);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (item === null) return false;

    const selectedItem = item[0];

    const sellerURL = `/api/sellers/${selectedItem.seller_id}/shop`;
    const productURL = `/api/products/${selectedItem.sku}`;

    const { thumbnail, small_image, name, description } = selectedItem;

    // const itemLink = `/item/${util.convertToUrlKey(name)}/${sku}`;

    let itemDescription;

    if (description) {
        itemDescription = description.replace(
            /(<script(\s|\S)*?<\/script>)|(<style(\s|\S)*?<\/style>)|(<!--(\s|\S)*?-->)|(<\/?(\s|\S)*?>)/g,
            ""
        );
        itemDescription = itemDescription.replace(/(&)([A-z]+)(;)/g, "");
    }

    const handleMoreInfoClick = () => {
        // Push click event to Google Tag Manager
        Analytics.click(
            CannabisShowcaseAnalytics.makeInformationEventProperties(
                "Cannabis Showcase Information CTA_",
                selectedItem,
                productData.external_link
            )
        );
    };

    if (error) return (
        <div className="cannabisshowcase-modal__content">
            <div className="cannabisshowcase-modal__content-thumbnail">
                <img
                    src="https://placehold.it/300x300/d2232a/ffffff/?text=Error"
                    alt="Error"
                    loading="lazy"
                />
            </div>
            <aside>
                <section>
                    <h2>Oops! Something went wrong!</h2>
                    <p>The application has encountered an unknown error. Help us improve your experience by sending an error report.</p>
                </section>
            </aside>
        </div>
    );

    return (
        <div className="cannabisshowcase-modal__content">
            <div className="cannabisshowcase-modal__content-thumbnail">
                {small_image || thumbnail ? (
                    <img
                        src={`${restUrl}/pub/media/catalog/product${small_image ||
                            thumbnail}`}
                        alt={name}
                        loading="lazy"
                    />
                ) : (
                    <img
                        src={`/images/image-not-found.png`}
                        alt={name}
                        loading="lazy"
                    />
                )}
            </div>
            <aside>
                <section>
                    {name && <h2>{name}</h2>}
                    {loading ? (
                        <h3>Loading...</h3>
                    ) : sellerData === null || error ? (
                        <h3>Undefined</h3>
                    ) : (
                        <h3>By: {sellerData.shop_title}</h3>
                    )}
                    {description && <p>{itemDescription}</p>}
                </section>
                {/* <a href={itemLink} onClick={handleMoreInfoClick}>More Information</a> */}
                {productData === null || error ? (
                    false
                ) : (
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={
                            productData.external_link
                                ? productData.external_link
                                : "#"
                        }
                        onClick={handleMoreInfoClick}
                    >
                        {productData.external_link_text || "More Information"}
                    </a>
                )}
            </aside>
        </div>
    );
};

CannabisShowCaseModal.defaultProps = {
    item: [],
    restUrl: ""
};

CannabisShowCaseModal.propTypes = {
    item: PropTypes.array,
    restUrl: PropTypes.string
};

export default CannabisShowCaseModal;
